module.exports = __webpack_public_path__ + "static/media/logo.5bd78d3f.png";